module.exports = __webpack_public_path__ + "static/img/050404.6b9c6c1f.png";